import { useMemo } from "react";
import { AttributeType, ColumnDescriptionDc } from "@evergis/api";

import { filterGeometryAttributes, getGeometryAttributes } from "../../../../evergis/core/attributes/attributes";
import { AttributesUpdate, useAttributes } from "../../../../hooks/attributes/useAttributes";
import { TableAttribute } from "../components/Table/TableAttributeItem";

export const useTableAttributes = (
  tableAttributes: ColumnDescriptionDc[],
): [TableAttribute[], AttributesUpdate<TableAttribute>] => {
  const createdAttributesState = useMemo(() => createAttributesState(tableAttributes), [tableAttributes]);

  return useAttributes(createdAttributesState);
};

function createAttributesState(tableAttributes: ColumnDescriptionDc[]): TableAttribute[] {
  if (tableAttributes) {
    const geometryAttributes = getGeometryAttributes(tableAttributes);
    const attributes = filterGeometryAttributes(tableAttributes).map(({ name, type, hasIndex }, index) => ({
      id: `${index}`,
      name,
      type,
      editable: false,
      hasIndex,
    }));

    return [...attributes, ...geometryAttributes];
  }
}

export const createTableAttribute = (id: string): TableAttribute => ({
  id,
  name: "",
  type: AttributeType.String,
  editable: true,
  hasIndex: false,
});
